var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section section-bold" }, [
    _c("div", { staticClass: "section-title" }, [
      _vm._v("\n\t\t" + _vm._s(_vm.title) + "\n\t\t"),
      _c(
        "span",
        { staticClass: "category-title-btn", on: { click: _vm.close } },
        [_c("i", { staticClass: "material-icons md-14" }, [_vm._v("close")])]
      )
    ]),
    _vm._v(" "),
    _c("form", { staticClass: "section-body" }, [
      _c("div", { staticClass: "category" }, [
        _c("div", { staticClass: "category-title overflow-hidden" }, [
          _vm._v("\n\t\t\t\tDESCRIPTION\n\t\t\t")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.string",
                value: _vm.rec.description,
                expression: "rec.description",
                modifiers: { string: true }
              }
            ],
            staticClass: "form-control form-control-sm",
            attrs: { placeholder: "short description" },
            domProps: { value: _vm.rec.description },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.rec, "description", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "category-title overflow-hidden" }, [
          _vm._v("\n\t\t\t\tURL\n\t\t\t")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.string",
                value: _vm.rec.url,
                expression: "rec.url",
                modifiers: { string: true }
              }
            ],
            staticClass: "form-control form-control-sm",
            attrs: { placeholder: "full URL" },
            domProps: { value: _vm.rec.url },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.rec, "url", $event.target.value)
              }
            }
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "section-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-sm btn-primary float-right",
          on: { click: _vm.submit }
        },
        [_vm._v(_vm._s(_vm.submitLabel))]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40ae45e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40ae45e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/community-plan/reference-form.vue
// module id = null
// module chunks = 